export enum INPUT_CONSTRAINTS {
  SSN_LENGTH = 10,
  MAX_NAME_LENGTH = 50,
  MAX_ADDRESS_LENGTH = 50,
  MAX_PHONE_NUMBER_LENGTH = 7,
  MAX_EMAIL_LENGTH = 50,
  MAX_COMMENTS_LENGTH = 50,
  MAX_QUANTITY = 100,
  MAX_WEIGHT = 30000,
  MAX_CONTACT_NAME_LENGTH = 20,
  MAX_DETAIL_DESCRIPTION_LENGTH = 20,
}

export enum DOMESTIC_KIOSK_INPUT_CONSTRAINTS {
  MAX_BOOKING_NO_LENGHT = 9,
}

export enum ERROR_LABELS {
  INVALID_PHONE = "ERROR_DOMESTIC_INVALID_PHONE",
  BOOKING_NOT_FOUND = "ERROR_DOMESTIC_BOOKING_NOT_FOUND",
}

export enum TRANSLATION_LABELS {
  CUSTOMER_AUTOCOMPLETE = "INFO_DOMESTIC_CREATE_CUSTOMER_AUTOCOMPLETE",
  COMPANY_AUTOCOMPLETE = "INFO_DOMESTIC_CREATE_COMPANY_AUTOCOMPLETE",
  DEPARTMENT_PREFILL = "INFO_DEPARTMENT_PREFILL",
  ADDRESS_PREFILL = "INFO_ADDRESS_PREFILL",
  PERSON_DETAILS = "INFO_PERSON_DETAILS",
  USE_DIFFERENT_ADDRESS = "LABEL_USE_DIFFERENT_ADDRESS",
  ADDRESS = "LABEL_ADDRESS",
  DEPOT = "LABEL_DOMESTIC_DEPOT",
  COLLECTION_SENDER_ADDRESS = "INFO_DOMESTIC_COLLECTION_SENDER_ADDRESS",
  COLLECTION_SENDER_DEPOT = "INFO_DOMESTIC_COLLECTION_SENDER_DEPOT",
  PROVIDE_COLLECTION_CONTACT_DETAILS = "INFO_PROVIDE_COLLECTION_CONTACT_DETAILS",
  COPY_FROM_SENDER = "LABEL_COPY_FROM_SENDER",
  DELIVERY_RECEIVER_ADDRESS = "INFO_DOMESTIC_DELIVERY_RECEIVER_ADDRESS",
  DELIVERY_RECEIVER_DEPOT = "INFO_DOMESTIC_DELIVERY_RECEIVER_DEPOT",
  COPY_FROM_RECEIVER = "LABEL_COPY_FROM_RECEIVER",
  PROVIDE_DELIVERY_CONTACT_DETAILS = "INFO_PROVIDE_DELIVERY_CONTACT_DETAILS",
  CLOSEST_WAREHOUSE = "INFO_DOMESTIC_CLOSEST_WAREHOUSE",
}

///^\+?[0-9]{3}\s?[0-9]{4}$|^$/;
export const PHONE_REGEX = /^[0-9]{7}$|^$/;

export const DOMESTIC_KIOSK_BOOKING_NO_REGEX = /^[0-9]{9,}$/;

export enum BOOKING_PARTY {
  SENDER = "SENDER",
  RECEIVER = "RECEIVER",
}

export const enum BOOKING_PARTY_TYPE {
  COMPANY = "COMPANY",
  PERSON = "PERSON",
}

export enum DELIVERY_MODE {
  DEPOT = "DEPOT", // Brought or picked up by customer
  ADDRESS = "ADDRESS", // Picked up or delivered by samskip to party address
}

export enum PAYER_TERM_TYPE {
  D2D = "D2D", // Door to door
  D2H = "D2H", // Door to hub
  H2D = "H2D", // Hub to Door
  H2H = "H2H", // Hub to hub
}

export enum CUSTOMER_SOURCE {
  SINNA = "SINNA",
  NATREG = "NATREG",
}

export const ICELAND_ISO_CODE = "IS";

export const enum RECEIPT_DELIVERY_PLACES {
  PLR = "PLR",
  PFD = "PFD",
}
